export default __webpack_public_path__ + "static/media/ic-attention.eabc18fd.webp";